import SelectPeriod from "../../components/select-period/select-period"
import DataGrid, {
    Column,
    Format,
    Grouping,
    Pager,
    Paging,
    Scrolling, Sorting, FilterRow, HeaderFilter, Editing, Selection
} from 'devextreme-react/data-grid'
import {Button, Button as DefButton} from 'devextreme-react/button'
import {getDogovorSf, getTypeFinDocs} from "../../api/dogovor"
import {useAuth} from '../../contexts/auth'
import notify from "devextreme/ui/notify"
import React, {useCallback, useEffect, useState} from "react"
import LoadPanel from 'devextreme-react/load-panel'
import {usePeriod} from "../../contexts/period"
import './findocs.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileInvoice, faFileLines} from "@fortawesome/free-solid-svg-icons";
import AccessDenied from "../../components/access-denied/access-denied"
import {verifyAccess, dogHasParameterMenu} from "../../utils/admin.utils"
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon";
import {Popup, TextBox} from "devextreme-react";
import {Buffer} from "buffer";
import {Get, GetDocs} from "../../api/report";
import {SelectBox} from "devextreme-react/select-box";
import findHeaderValue from "../../utils/find-header";
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import {useScreenSize} from "../../utils/media-query";

const FinDocs = () => {
    const {selectedDog} = useAuth()
    const [finDocs, setFinDocs] = useState([])
    const [typeFinDocs, setTypeFinDocs] = useState([])
    const [loading, setLoading] = useState(false)
    const { periodStart, periodEnd } = usePeriod()
    const [visiblePage, setVisiblePage] = useState(true)
    const [visibleIframe, setVisibleIframe] = useState(false)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [prevSelect, setPrevSelect] = useState(0)
    let { isXSmall } = useScreenSize();
    const envTat = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt';
    const envRenegy = process.env.REACT_APP_NAME_ENV === 'renergy'

    useEffect(() => {
        const pageRoles = [3]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
            return
        }
        (async function(){
            try {
                setVisiblePage(true)
                setFinDocs([])
                const kodDog = selectedDog?.kodDog
                setLoading(true)

                const resFD = await getTypeFinDocs()
                if (resFD.isOk) {
                    setTypeFinDocs(resFD.data.result)
                    const res = await getDogovorSf(kodDog, periodStart, periodEnd)
                    if (res.isOk) {
                        let rezult = []
                        for (let item of res.data){
                            let filteredDocs = resFD.data.result.filter(e => {
                                // Первое условие: vid_real должно совпадать
                                const condition1 = e.vid_real === item.vidReal;
                                // Второе условие: если props.data.vid_pl != 3, то исключаем элементы с abbr = 'Schet_plat'
                                const condition2 = !(+item.vid_pl !== 3 && e.abbr && e.abbr === 'Schet_plat');

                                // Третье условие: если фикс или ГП, то исключаем элементы с abbr = 'OFZ'
                                const condition3 = !((dogHasParameterMenu(selectedDog, '3') || dogHasParameterMenu(selectedDog, '2')) && e.abbr === 'OFZ');
                                // Четвёртое условие: не сформирован акт сверки, то исключаем элементы с abbr = 'AktSv_31'
                                const condition4 = !(+item.akt_sv === 0 && e.abbr && e.abbr.startsWith('AktSv'));

                                return condition1 && condition2 && condition3 && condition4;
                            });
                            item.isDisabled = !(filteredDocs.length !== 0);
                            rezult.push(item);
                        }
                        setFinDocs(rezult);
                    } else {
                        notify(res.message, 'error', 5000)
                    }
                } else {
                    notify(resFD.message, 'error', 5000)
                }


            } catch (e) {
                notify(e.message, 'error', 5000)
            } finally {
                setLoading(false)
            }

        })()
    },[selectedDog,periodStart,periodEnd])

    const getIzv = useCallback(async (e,data) => {
        //setLoading(true)
        notify(`Начато формирование файла. Не обновляйте и не закрывайте браузер.`, 'success', 5000);
        try {
            let {kodSf} = data
            let name = e.abbr

            const res = await Get(name, kodSf)
            if (res.isOk) {
                let filename = findHeaderValue(res.data.headers, 'Content-Disposition', 'FileName')
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(res.data.data.data), filename)
                notify(`Файл ${filename} загружен.`, 'success', 5000);
            } else {
                notify(res.message, 'error', 4000);
            }
        } catch (e) {
            notify(e.message, 'error', 4000);
        } finally {
            //setLoading(false)
        }
    }, []);

    const showIframe = async (e, data) => {
        let {kodSf} = data
        let name = e.abbr
        let url = window.location.origin
        if (url.includes('localhost')) url = 'http://localhost:3100'
        let src = `${url}/api/report/show?name=${name}&id=${kodSf}`;
        if (isXSmall) {
            window.open(src, '_blank');
            return
        }
        setVisibleIframe(true)
        await new Promise((resolve) => setTimeout(resolve, 100))
        let divContainerIframe = document.getElementById('divContainerIframe')
        // Создаем элементы
        const loaderWrapper = document.createElement('div');
        loaderWrapper.style.position = 'absolute';
        loaderWrapper.style.top = '0';
        loaderWrapper.style.left = '0';
        loaderWrapper.style.width = '100%';
        loaderWrapper.style.height = '100%';
        loaderWrapper.style.display = 'flex';
        loaderWrapper.style.flexDirection = 'column';
        loaderWrapper.style.justifyContent = 'center';
        loaderWrapper.style.alignItems = 'center';
        loaderWrapper.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
        loaderWrapper.style.zIndex = '1000';

        const loaderGif = document.createElement('img');
        loaderGif.src = '/Loading_icon.webp'; // пример гифки
        loaderGif.style.width = '200px';
        //loaderGif.style.height = '50px';

        const loaderText = document.createElement('div');
        loaderText.textContent = 'Идет формирование документа...';
        loaderText.style.marginTop = '10px';
        loaderText.style.fontSize = '14px';
        loaderText.style.color = '#333';

        // Добавляем элементы в обертку
        loaderWrapper.appendChild(loaderGif);
        loaderWrapper.appendChild(loaderText);

        // Вставляем в контейнер iframe
        let f = document.createElement('iframe');
        f.src = src
        f.className = 'iframe-findocs'
        divContainerIframe.append(f);
        divContainerIframe.appendChild(loaderWrapper);
        f.onload = function() {
            loaderWrapper.style.display = 'none';
            divContainerIframe.removeChild(loaderWrapper)
        };
        f.onerror = function() {
            loaderWrapper.style.display = 'none';
            divContainerIframe.removeChild(loaderWrapper)
            console.error('Ошибка загрузки');
        };
    }

    const closeIframe = async () => {
        let divContainerIframe = document.getElementById('divContainerIframe')
        if (divContainerIframe.getElementsByTagName('iframe')[0]) {
            divContainerIframe?.removeChild(divContainerIframe.getElementsByTagName('iframe')[0]);
        }
        setVisibleIframe(false)
    }

    const itemRender = (item, data) => {
        return (
            <div className="button-in-dropdown" onClick={(e) => {
                e.stopPropagation();
                return false;
            }}>
                <div title="Нажмите на кнопку справа" className="item-name">
                    {item.name}
                </div>
                <div className="buttons-container">
                    <div className="buttons-download">
                        {item.abbr !== 'All' && (
                            <Button
                                hint="Открыть документ"
                                icon="eyeopen"
                                title="Открыть документ"
                                onClick={() => showIframe(item, data)}
                            />
                        )}
                        <Button
                            hint="Скачать документ"
                            icon="download"
                            onClick={() => getIzv(item, data)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    const fieldRender = () => {
        //const selected = statuses.find(s => s.id === value);
        return <TextBox disabled={true}
            defaultValue='Выберите'/>;//<span>{selected?.name || 'Выберите статус'}</span>;
    };

    const calcFilteredDocs = (props) => {
        let filteredDocs = typeFinDocs.filter(e => {
            // Первое условие: vid_real должно совпадать
            const condition1 = e.vid_real === props.data.vidReal;
            // Второе условие: если props.data.vid_pl != 3, то исключаем элементы с abbr = 'Schet_plat'
            const condition2 = !(+props.data.vid_pl !== 3 && e.abbr && e.abbr === 'Schet_plat');
            // Третье условие: если фикс или ГП, то исключаем элементы с abbr = 'OFZ'
            const condition3 = !((dogHasParameterMenu(selectedDog, '3') || dogHasParameterMenu(selectedDog, '2')) && e.abbr === 'OFZ');
            // Четвёртое условие: не сформирован акт сверки, то исключаем элементы с abbr = 'AktSv_31'
            const condition4 = !(+props.data.akt_sv === 0 && e.abbr && e.abbr.startsWith('AktSv'));
            return condition1 && condition2 && condition3 && condition4;
        });

        return filteredDocs.length > 0
            ? [...filteredDocs,{"id":"100","name":"Скачать все","sort":"1","abbr":"All"}]
            : [];
    }

    const statusEditorRender = (props) => {
        const filteredDocs = calcFilteredDocs(props)
        return (
            <SelectBox
                className={'disabled-select-normal-opacity'}
                dataSource={filteredDocs}
                disabled={filteredDocs.length === 0}
                value={props.value}
                valueExpr="id"
                displayExpr="name"
                onChange={(e)=>e.preventDefault()}
                fieldRender={() => fieldRender(props.value)}
                itemRender={(e) => itemRender(e, props.data)}
                dropDownOptions={{
                    resizeEnabled: true, minWidth: '239px'
                }}
            />
        );
    };


    const onSelectionChanged = async (e) => {
        e.component.refresh(true);
        const deselectRowKeys = [];


        e.selectedRowsData.forEach((item) => {
            if (item.isDisabled)
                deselectRowKeys.push(e.component.keyOf(item));
        });
        if (deselectRowKeys.length) {
            e.component.deselectRows(deselectRowKeys);
        }

        // логика снятия selectAll checkbox
        let count = finDocs.filter(e => !e.isDisabled).length
        setPrevSelect(e.selectedRowKeys.length)
        if (e.currentDeselectedRowKeys.length === 0 && prevSelect === count){
            e.component.clearSelection();
            setSelectedRowKeys([])
            e.component.refresh(true);
            return;
        }
        // конец

        // selectionRef.current.checkBoxUpdating = true;
        // const selectAllCheckBox = selectionRef.current.selectAllCheckBox;
        // selectAllCheckBox?.option("value", isSelectAll(e.component));
        // selectionRef.current.checkBoxUpdating = false;
        //e.component.refresh(true);

        let selectArray = e.selectedRowKeys
        setSelectedRowKeys(selectArray)
    }

    const downloadSelect = async () => {
        notify(`Начато формирование файла. Не обновляйте и не закрывайте браузер.`, 'success', 5000);
        try {
            const res = await GetDocs(selectedRowKeys)
            if (res.isOk) {
                let filename = findHeaderValue(res.data.headers, 'Content-Disposition', 'FileName')
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(res.data.data.data), filename)
                notify(`Файл ${filename} загружен.`, 'success', 5000);
            } else {
                notify(res.message, 'error', 4000);
            }
        } catch (e) {
            notify(e.message, 'error', 4000);
        } finally {

        }
    }

    const onRowPrepared = (e) => {
        if (e.rowType === 'data' && e.data.isDisabled) {
            e.rowElement.classList.add('disabled-row');
        }
    };

    return (
        <>{visiblePage ?
        <div className={'content-block dx-card responsive-paddings findocs'}>
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileInvoice} />
            <h3><strong><ZagolovokFromMenu/></strong></h3>
            <div className="row mt20 mb20 big-input" style={{alignItems: 'baseline'}}>

                    <SelectPeriod mode={'multiple'}/>
                <div className={'col-sm-4 col-md-3 col-lg-2 mt20xs mt20md'}>
                    <DefButton text="Скачать выбранные" onClick={() => downloadSelect()} disabled={selectedRowKeys.length === 0}  style={{minWidth: '200px'}} className='block' icon="download" ></DefButton>
                </div>
            </div>
                <DataGrid
                    dataSource={finDocs}
                    noDataText="Нет документов за указанный период"
                    keyExpr="kodSf"
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    rowAlternationEnabled={true}
                    showBorders={true}
                    //onContentReady={this.onContentReady}
                    wordWrapEnabled={true}
                    /*columnWidth={'auto'}*/
                    width={'100%'}
                    onSelectionChanged={onSelectionChanged}
                    onRowPrepared={onRowPrepared}
                >
                    {/* <GroupPanel visible={true} /> */}
                    {/* <SearchPanel visible={true} highlightCaseSensitive={true} /> */}
                    <Selection
                        mode="multiple"
                        selectAllMode='allPages'
                        showCheckBoxesMode='always'
                    />
                    <Editing mode="cell"/>
                    <Grouping autoExpandAll={false} />
                    <Scrolling columnRenderingMode="virtual" />
                    <Paging defaultPageSize={12} />
                    <Pager
                        visible={true}
                        allowedPageSizes={[5, 12, 20, 'all']}
                        displayMode={'full'}
                        showPageSizeSelector={true}
                        showInfo={true}
                        showNavigationButtons={true} />
                    <Sorting mode="multiple" />
                    <FilterRow
                        visible={true} />
                    <HeaderFilter visible={true} />

                    <Column
                        width={envTat ? '133px': '180px'}
                        dataField="kodSf"
                        caption={envTat ? "Документы для просмотра и скачивания" : "Документы"}
                        cellRender={statusEditorRender}
                    />
                    <Column dataField="rym" caption="Период потребления" dataType="string" width="120px"
                            cellRender={e => {
                                if (e.value == null) return ''
                                return e.value.toString().endsWith('.1') ? e.value.toString() + '0' : e.value.toString()
                            }}
                    />
                    <Column dataField="nameDoc" minWidth={150} caption="Тип документа" dataType="string" />

                    <Column dataField="nomSf" caption={envTat ? "Номер документа" : "Номер документа начисления"} visibleIndex={envRenegy ? 10 : 3}
                         dataType="string" width="150px"/>
                    <Column dataField="datSf" caption={envTat ? "Дата документа" : "Дата документа начисления"} visible={envTat} dataType="date"  width="120px"/>
                    <Column dataField="d_c" visible={!envRenegy} caption="Дата размещения документа в ЛК" dataType="date" width="120px"/>
                    <Column dataField="sumNach" caption="Начислено с налогом" alignment="right" dataType="numeric" width="120px">
                    <Format type="currency" precision={2} currency={'RUB'}/>
                    </Column>
                    <Column dataField="sumOpl" caption={envTat ? "Оплачено" : "Сумма оплаты"} alignment="right" dataType="numeric" width="150px">
                    <Format type="currency" precision={2} currency={'RUB'}/>
                    </Column>
                    <Column dataField="sumDolg" caption="Задолженность" alignment="right" dataType="numeric" width="100px" >{/*cellRender={sfRender}*/}
                    <Format type="currency" precision={2} currency={'RUB'}/>
                    </Column>
                </DataGrid>
                <LoadPanel  shading={true} visible={loading} shadingColor="rgba(0,0,0,0.4)"/>
                <Popup visible={visibleIframe}
                       hideOnOutsideClick={true}
                       showCloseButton={true}
                       onHiding={closeIframe}
                       showTitle={true}
                       maxWidth={1200}
                       maxHeight={'90%'}
                       height={'auto'}
                       titleRender={()=>PopupTitleWithIcon(faFileLines, "Просмотр документа",closeIframe)}
                >
                    <div id="divContainerIframe" className='findocs'></div>
                </Popup>
        </div>
        : <AccessDenied/>}</>
    )
}

export default FinDocs
